import queryString from 'query-string'

import type {
  IDeleteResultsBody,
  IMeasurementResult,
  IMeasurementResultSummary,
  IResultParams
} from '@web/entities/chart'
import { ApiResource, ApiTag } from '@web/shared/constants/api.constants'
import { baseApi } from '@web/shared/infrastructure/api-base-query'
import type { TId } from '@web/shared/types/id.type'
import type { IPagination } from '@web/shared/types/paged-response.type'

export const resultsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMeasurementResults: builder.query<
      IPagination<IMeasurementResult>,
      { measurementId: TId; params: IResultParams }
    >({
      query: ({ measurementId, params }) => {
        const query = queryString.stringify(params, { arrayFormat: 'comma' })

        return {
          url: `${ApiResource.Measurements}/${measurementId}/results?${query}`
        }
      },
      providesTags: [ApiTag.Results]
    }),

    getMeasurementResultsSummary: builder.query<
      IPagination<IMeasurementResultSummary>,
      { measurementId: TId; params: IResultParams }
    >({
      query: ({ measurementId, params }) => {
        const query = queryString.stringify(params, { arrayFormat: 'comma' })

        return {
          url: `${ApiResource.Measurements}/${measurementId}/results/summary?${query}`
        }
      },
      providesTags: [ApiTag.Results]
    }),

    deleteMeasurementResults: builder.mutation<
      void,
      { measurementId: TId; body: IDeleteResultsBody }
    >({
      query: ({ measurementId, body }) => ({
        method: 'DELETE',
        url: `${ApiResource.Measurements}/${measurementId}/results`,
        body
      }),
      invalidatesTags: [ApiTag.Results]
    })
  })
})

export const {
  useLazyGetMeasurementResultsQuery,
  useGetMeasurementResultsSummaryQuery,
  useDeleteMeasurementResultsMutation
} = resultsApi
